import axios from 'axios';
import { axiosInstance } from '../../api/api';

// const defectApi = axios.create({
// 	baseURL: 'https://d46bfc3ef1d2.ngrok-free.app/defect',
// });

/**
 * Fetch defect details for a given VIN
 * @param {string} serialNumber
 * @param {function} successCallback
 * @param {function} errorCallback
 */
export const fetchDefectDetails = (
	serialNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.get(`/defect/details?vin=${serialNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

/**
 * Fetch open defect status for a given VIN
 * @param {string} serialNumber
 * @param {function} successCallback
 * @param {function} errorCallback
 */
export const fetchOpenDefectStatus = (
	serialNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.get(`/defect/openDefectStatus?vin=${serialNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};
// Station APIs from different host
// const stationApi = axios.create({
// 	baseURL: 'https://960a2665b700.ngrok-free.app/station',
// });

/**
 * MAssist call for defect check
 * @param {string} serialNumber
 */
export const massistCallForDefectCheck = (
	serialNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.post(`/station/wtcl/massistDefectCheck/${serialNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

/**
 * Check SAP VIN status before WTCL flow
 * @param {string} serialNumber
 */
export const fetchSapVinStatus = (
	serialNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.get(`/station/wtcl/sap-vin-status?serialNumber=${serialNumber}`)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

/**
 * Perform privileged action (WTCL Override)
 * @param {string} sequenceNumber
 * @param {object} payload
 */
export const wtclOverride = (
	sequenceNumber,
	payload,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.post(
				`/station/perform-privileged-action/wtcl/${sequenceNumber}`,
				payload,
			)
			.then(({ data }) => {
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};
};

/**
 * Complete WTCL operation
 * @param {string} sequenceNumber
 * @param {function} successCallback
 * @param {function} errorCallback
 */
export const completeWTCL = (
	sequenceNumber,
	successCallback,
	errorCallback,
) => {
	return () => {
		axiosInstance
			.post(`/station/wtcl/${sequenceNumber}`)
			.then(({ data }) => {
				if (typeof successCallback === 'function') {
					successCallback(data);
				}
			})
			.catch((err) => {
				if (typeof errorCallback === 'function') {
					errorCallback(err);
				}
			});
	};
};
